var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.502,
    height: 99.479,
    viewBox: "0 0 99.502 99.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 -0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.056)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M94.776,51.462a31.485,31.485,0,0,0-18.494-13.8v-6.1a4.975,4.975,0,0,0,0-9.95H71.307V16.639H79.6a1.658,1.658,0,0,0,1.658-1.658V6.689A6.633,6.633,0,0,0,74.624.056H13.266A6.633,6.633,0,0,0,6.633,6.689V73.022H1.658A1.658,1.658,0,0,0,0,74.68V78A6.633,6.633,0,0,0,6.633,84.63H41.25A31.485,31.485,0,0,0,94.776,51.462ZM71.307,6.689a3.317,3.317,0,1,1,6.633,0v6.633H71.307Zm4.975,18.241a1.658,1.658,0,1,1,0,3.317H59.7a1.658,1.658,0,0,1,0-3.317H76.282ZM9.95,6.689a3.316,3.316,0,0,1,3.317-3.317H68.913a6.566,6.566,0,0,0-.922,3.317V21.614H59.7a4.975,4.975,0,1,0,0,9.95v6.1A31.213,31.213,0,0,0,36.916,73.022H9.95ZM6.633,81.313A3.317,3.317,0,0,1,3.317,78V76.338h34.31a31.225,31.225,0,0,0,1.824,4.975ZM67.991,96.238A28.18,28.18,0,0,1,61.726,40.58a1.658,1.658,0,0,0,1.29-1.619v-7.4h9.95v7.4a1.658,1.658,0,0,0,1.29,1.619,28.18,28.18,0,0,1-6.265,55.658Z",
    transform: "translate(0 -0.056)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.56 47.447)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M235.33,228.681a23.3,23.3,0,0,0-10.714,11.655l3.061,1.279a19.978,19.978,0,0,1,9.185-9.993Z",
    transform: "translate(-224.616 -228.681)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.781 62.849)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M262.382,306.478a1.658,1.658,0,0,0-2.827-1.055l-1.274,1.265a5.823,5.823,0,0,1-8.228,0l-1.033-1.033a9.147,9.147,0,0,0-12.922,0l-1.033,1.033a5.823,5.823,0,0,1-8.229,0,9.167,9.167,0,0,0-9.618-2.091,1.658,1.658,0,0,0-1.076,1.4c-.066.716-.11,1.439-.11,2.174a23.216,23.216,0,0,0,46.433,0C262.465,307.657,262.43,307.148,262.382,306.478Zm-23.14,21.6a19.921,19.921,0,0,1-19.9-19.9c0-.247,0-.5.017-.736a5.82,5.82,0,0,1,5.131,1.6,9.147,9.147,0,0,0,12.922,0l1.033-1.033a5.823,5.823,0,0,1,8.229,0l1.033,1.033a9.155,9.155,0,0,0,11.321,1.277A19.928,19.928,0,0,1,239.242,328.081Z",
    transform: "translate(-216.032 -302.983)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.848 45.104)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M297.116,217.377a23.255,23.255,0,0,0-3.572.846l1.018,3.151a19.808,19.808,0,0,1,3.061-.72Z",
    transform: "translate(-293.544 -217.377)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(74.099 69.905)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 1,
    height: 4,
    transform: "translate(0.403 0.239)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.165 76.513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 5,
    transform: "translate(0.337 -0.368)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.268 81.232)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 2,
    transform: "translate(0.235 -0.088)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.266 8.348)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M95.9,46.69l-5.366-2.683v-3.95H87.216v3.95l-4.975,2.487-4.975-2.487v-3.95H73.95v3.95l-5.716,2.857a1.659,1.659,0,0,0-.917,1.484v6.633H64V58.3h4.584l5.366,2.683v3.95h3.317v-3.95l4.975-2.487,4.975,2.487v3.95h3.317v-3.95l5.716-2.849a1.658,1.658,0,0,0,.917-1.492V50.007h3.317V46.69ZM80.583,55.615,75.608,58.1l-4.975-2.487V49.373l4.975-2.487,4.975,2.487Zm13.266,0L88.875,58.1,83.9,55.615V49.373l4.975-2.487,4.975,2.487Z",
    transform: "translate(-64 -40.057)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.689 43.476)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28,
    height: 5,
    transform: "translate(-0.187 -0.331)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.689 50.083)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 23,
    height: 5,
    transform: "translate(-0.187 0.062)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.689 57.635)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 4,
    transform: "translate(-0.187 -0.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.016 37.812)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 3,
    transform: "translate(0.486 0.332)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.277 10.439)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2,
    height: 5,
    transform: "translate(0.225 -0.294)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.409 37.812)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 3,
    height: 3,
    transform: "translate(0.094 0.332)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(59.941 10.439)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 5,
    height: 5,
    transform: "translate(-0.438 -0.294)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.2355a8a37eed6affcd93b275a4db10eb.svg";
export { ForwardRef as ReactComponent };